import { ExclamationCircleFilled } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const formatValidity = (days) => {
  if (!days) return '-';
  const years = Math.floor(days / 365);
  const months = Math.floor((days % 365) / 30);
  const remainingDays = (days % 365) % 30;
  const parts = [
    years > 0 && `${years} ${years === 1 ? 'año' : 'años'}`,
    months > 0 && `${months} ${months === 1 ? 'mes' : 'meses'}`,
    remainingDays > 0 && `${remainingDays} ${remainingDays === 1 ? 'día' : 'días'}`,
  ].filter(Boolean);
  return parts.join(' ') || '-';
};

const LinkedExamBanner = ({ variant, examInfo, className = '' }) => {
  const { t } = useTranslation();

  return (
    <div className={`vigent-exam-alert ${className}`}>
      <ExclamationCircleFilled className="icon" />
      <span>
        {t(`examPage.linkedExamBanner.${variant}`)} <br />
        {t('examPage.linkedExamBanner.date')}
        <strong className="mr-20"> {examInfo?.examDate ? new Date(examInfo.examDate).toLocaleDateString('es-CL') : '-'} </strong>
        {t('examPage.linkedExamBanner.branch')}
        <strong className="mr-20"> {examInfo?.branchOffice || '-'} </strong>
        {t('examPage.linkedExamBanner.criterion')}
        <strong className="mr-20"> {examInfo?.validityCriterion || '-'} </strong>
        {t('examPage.linkedExamBanner.validity')}
        <strong> {formatValidity(examInfo?.validationDate)} </strong>
      </span>
    </div>
  );
};

export { formatValidity };
export default LinkedExamBanner;